(function () {
  'use strict';

  if (window.__aeenCardsInit) return;
  window.__aeenCardsInit = true;

  var cartState = null;
  var cartRequest = null;
  var cartVariantQuantities = Object.create(null);

  function route(path) {
    var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    return root.replace(/\/$/, '') + '/' + path.replace(/^\//, '');
  }

  function requestJSON(url, options) {
    return fetch(url, options).then(function (response) {
      if (response.ok) return response.json();
      return response.json().catch(function () {
        return {};
      }).then(function (error) {
        throw error;
      });
    });
  }

  function mainImage(card) {
    return card && card.querySelector('.aeen-card-image, [data-aeen-card-image]');
  }

  function setImage(image, url) {
    if (!image || !url) return;
    image.removeAttribute('srcset');
    image.src = url;
  }

  function quantitiesFromCart(cart) {
    var quantities = Object.create(null);
    (cart && cart.items ? cart.items : []).forEach(function (item) {
      var id = String(item.variant_id || item.id);
      quantities[id] = (quantities[id] || 0) + Number(item.quantity || 0);
    });
    return quantities;
  }

  function buttonLabel(button) {
    return button && button.querySelector('.aeen-c-add__t em');
  }

  function syncCardButton(button) {
    if (!button) return;
    var variantId = String(button.dataset.vid || '');
    var quantity = cartVariantQuantities[variantId] || 0;
    var available = button.dataset.available !== '0';
    var inCart = quantity > 0;
    var label = buttonLabel(button);

    button.classList.toggle('is-in-cart', inCart);
    button.classList.toggle('is-disabled', !available || inCart);
    button.disabled = !available || inCart;
    button.setAttribute('aria-disabled', button.disabled ? 'true' : 'false');

    if (label) {
      if (!available) label.textContent = 'Sold out';
      else if (inCart) label.textContent = 'In bag · qty ' + quantity;
      else label.textContent = 'Add to cart';
    }
  }

  function productFormVariant(form) {
    if (!form) return '';
    var selected = form.querySelector('input[name="id"]:checked, select[name="id"], input[name="id"]');
    return selected && selected.value ? String(selected.value) : '';
  }

  function syncProductForm(form) {
    if (!form) return;
    var variantId = productFormVariant(form);
    if (!variantId) return;
    var button = form.querySelector('button[name="add"], input[name="add"], .single_add_to_cart_button, .product-form__submit, [data-product-add]');
    if (!button) return;
    var quantity = cartVariantQuantities[variantId] || 0;
    var inCart = quantity > 0;
    var label = button.querySelector('.txt_add, [data-add-to-cart-text], .button__text, .text');
    if (!label && !button.children.length) label = button;
    if (label && !label.dataset.aeenOriginalLabel) label.dataset.aeenOriginalLabel = label.textContent.trim();

    button.classList.toggle('is-aeen-in-cart', inCart);
    button.setAttribute('data-aeen-in-cart', inCart ? 'true' : 'false');
    if (inCart) {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      if (label) label.textContent = 'In bag · qty ' + quantity;
    } else if (button.getAttribute('data-available') !== '0' && !button.classList.contains('sold_out')) {
      button.disabled = false;
      button.setAttribute('aria-disabled', 'false');
      if (label && label.dataset.aeenOriginalLabel) label.textContent = label.dataset.aeenOriginalLabel;
    }
  }

  function syncButtons(root) {
    (root || document).querySelectorAll('.aeen-c-add[data-vid]').forEach(syncCardButton);
    (root || document).querySelectorAll('form[action*="/cart/add"]').forEach(syncProductForm);
  }

  function money(cents) {
    var moneyNode = document.querySelector('[data-aeen-money-format]');
    var moneyFormat = moneyNode ? moneyNode.getAttribute('data-aeen-money-format') : '';
    if (!moneyFormat && window.theme && window.theme.moneyFormat) moneyFormat = window.theme.moneyFormat;
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      try {
        if (moneyFormat) return Shopify.formatMoney(cents, moneyFormat);
      } catch (error) {}
    }
    var currency = window.Shopify && Shopify.currency && Shopify.currency.active ? Shopify.currency.active : 'PKR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-PK', {
        style: 'currency',
        currency: currency,
        maximumFractionDigits: 0
      }).format(Number(cents || 0) / 100);
    } catch (error) {
      return 'Rs. ' + (Number(cents || 0) / 100).toLocaleString();
    }
  }

  function syncHeader(cart) {
    if (!cart) return;
    document.querySelectorAll('.cart_count, .nt_cart_count, .jsccount, [data-cart-count-value], [data-cart-count]').forEach(function (node) {
      if (node.id === 'AEENCartPage') {
        node.setAttribute('data-cart-count', String(cart.item_count));
      } else if (node.hasAttribute('data-cart-count') && node.children.length) {
        node.setAttribute('data-cart-count', String(cart.item_count));
      } else {
        node.textContent = cart.item_count;
      }
    });

    var total = money(cart.total_price);
    document.querySelectorAll('#ntheader .js_cat_ttprice, .icon_cart .js_cat_ttprice, .the4-icon-cart .js_cat_ttprice, .type_toolbar_cart .js_cat_ttprice, [data-cart-total-value], [data-cart-price-value]').forEach(function (node) {
      if (node.closest && (node.closest('#nt_cart_canvas') || node.closest('#AEENCartPage'))) return;
      node.textContent = total;
    });
  }

  function adoptCart(cart) {
    cartState = cart;
    cartVariantQuantities = quantitiesFromCart(cart);
    syncHeader(cart);
    syncButtons(document);
    return cart;
  }

  function setCart(cart) {
    adoptCart(cart);
    document.dispatchEvent(new CustomEvent('aeen:cart:updated', { detail: { cart: cart } }));
    return cart;
  }

  function fetchCart(force) {
    if (cartState && !force) return Promise.resolve(cartState);
    if (cartRequest && !force) return cartRequest;
    cartRequest = requestJSON(route('cart.js'), { headers: { Accept: 'application/json' } })
      .then(setCart)
      .finally(function () {
        cartRequest = null;
      });
    return cartRequest;
  }

  function drawerOpener() {
    return document.querySelector('[data-opennt="#nt_cart_canvas"], .js_cart_sidebar, [data-canvas="cart"], .nt_menu_cart, .js_cart_canvas, .cart-link[data-opennt]');
  }

  function openDrawerLoading() {
    var drawer = document.querySelector('#nt_cart_canvas');
    if (drawer) {
      drawer.classList.add('aeen-cart-busy');
      drawer.setAttribute('aria-busy', 'true');
    }
    document.documentElement.classList.add('aeen-cart-opening');
    var opener = drawerOpener();
    if (opener && typeof opener.click === 'function') opener.click();
  }

  function finishDrawerLoading() {
    var drawer = document.querySelector('#nt_cart_canvas');
    if (drawer) {
      drawer.classList.remove('aeen-cart-busy');
      drawer.setAttribute('aria-busy', 'false');
    }
    document.documentElement.classList.remove('aeen-cart-opening');
  }

  function notify(error) {
    var message = error && (error.description || error.message) ? (error.description || error.message) : 'Could not add this item. Please try again.';
    if (window.AEEN && typeof AEEN.notify === 'function') AEEN.notify(message, true);
    else if (window.console) console.error(message);
  }

  function refreshThemeCart() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('aeen:cart:refresh', { bubbles: true }));
    if (window.jQuery) window.jQuery(document).trigger('nt_cart_updated');
    window.setTimeout(finishDrawerLoading, 900);
  }

  function addVariant(button) {
    var variantId = String(button.dataset.vid || '');
    if (!variantId || button.classList.contains('is-busy') || button.dataset.available === '0') return;

    button.classList.add('is-busy');
    button.setAttribute('aria-busy', 'true');
    openDrawerLoading();

    fetchCart(false).then(function (cart) {
      if ((quantitiesFromCart(cart)[variantId] || 0) > 0) return cart;

      button.classList.add('is-go');
      return requestJSON(route('cart/add.js'), {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      }).then(function () {
        return fetchCart(true);
      });
    }).then(function (cart) {
      setCart(cart);
      button.classList.remove('is-go');
      button.classList.add('is-done');
      refreshThemeCart();
      window.setTimeout(function () {
        button.classList.remove('is-done', 'is-busy');
        button.setAttribute('aria-busy', 'false');
        syncCardButton(button);
      }, 900);
    }).catch(function (error) {
      button.classList.remove('is-go', 'is-done', 'is-busy');
      button.setAttribute('aria-busy', 'false');
      finishDrawerLoading();
      notify(error);
    });
  }

  function selectSwatch(swatch) {
    var card = swatch.closest('.aeen-c-card');
    if (!card) return;
    var image = mainImage(card);
    var currentPrice = card.querySelector('[data-now]');
    var comparePrice = card.querySelector('[data-cmp]');
    var addButton = card.querySelector('.aeen-c-add');
    var saleFlag = card.querySelector('.aeen-c-flag--sale');
    var available = swatch.dataset.aeenAvailable === '1';

    if (image && swatch.dataset.aeenImg) {
      setImage(image, swatch.dataset.aeenImg);
      card.dataset.origImg = image.src;
    }
    if (currentPrice) currentPrice.textContent = swatch.dataset.aeenPrice || '';
    if (comparePrice) {
      comparePrice.textContent = swatch.dataset.aeenCmp || '';
      comparePrice.hidden = !swatch.dataset.aeenCmp;
    }
    if (saleFlag) saleFlag.style.display = swatch.dataset.aeenSale === '1' ? 'inline-flex' : 'none';
    if (addButton) {
      if (swatch.dataset.aeenVid) addButton.dataset.vid = swatch.dataset.aeenVid;
      addButton.dataset.available = available ? '1' : '0';
      syncCardButton(addButton);
    }

    card.querySelectorAll('.aeen-c-sw__b').forEach(function (item) {
      var active = item === swatch;
      item.classList.toggle('is-on', active);
      item.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    swatch.blur();
  }

  document.addEventListener('mouseover', function (event) {
    var swatch = event.target.closest && event.target.closest('.aeen-c-sw__b');
    if (!swatch || swatch.contains(event.relatedTarget)) return;
    var card = swatch.closest('.aeen-c-card');
    var image = mainImage(card);
    if (!image) return;
    if (card.dataset.origImg === undefined) card.dataset.origImg = image.src;
    setImage(image, swatch.dataset.aeenImg);
  });

  document.addEventListener('mouseout', function (event) {
    var swatch = event.target.closest && event.target.closest('.aeen-c-sw__b');
    if (!swatch || swatch.contains(event.relatedTarget)) return;
    var card = swatch.closest('.aeen-c-card');
    var image = mainImage(card);
    if (image && card.dataset.origImg !== undefined) setImage(image, card.dataset.origImg);
  });

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest && event.target.closest('.aeen-c-sw__b');
    if (swatch) {
      event.preventDefault();
      selectSwatch(swatch);
      return;
    }

    var button = event.target.closest && event.target.closest('.aeen-c-add[data-vid]');
    if (button) {
      event.preventDefault();
      if (!button.disabled && !button.classList.contains('is-in-cart')) addVariant(button);
    }
  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches('form[action*="/cart/add"] [name="id"]')) return;
    var form = event.target.closest('form');
    window.setTimeout(function () {
      syncProductForm(form);
    }, 0);
  });

  window.aeenTrack = function (root) {
    if (!root) return;
    var track = root.matches && root.matches('[data-track]') ? root : root.querySelector('[data-track]');
    if (!track || !track.children.length) return;

    function step() {
      var first = track.children[0];
      var gap = parseFloat(window.getComputedStyle(track).columnGap) || parseFloat(window.getComputedStyle(track).gap) || 0;
      return first ? first.getBoundingClientRect().width + gap : track.clientWidth;
    }

    function syncArrows() {
      var max = Math.max(0, track.scrollWidth - track.clientWidth - 2);
      root.querySelectorAll('.aeen-cs__arw').forEach(function (arrow) {
        var direction = Number(arrow.dataset.dir || 0);
        arrow.disabled = (direction < 0 && track.scrollLeft <= 2) || (direction > 0 && track.scrollLeft >= max);
      });
    }

    root.querySelectorAll('.aeen-cs__arw').forEach(function (arrow) {
      if (arrow.dataset.aeenTrackBound === '1') return;
      arrow.dataset.aeenTrackBound = '1';
      arrow.addEventListener('click', function () {
        track.scrollBy({ left: Number(arrow.dataset.dir || 0) * step(), behavior: 'smooth' });
      });
    });

    if (track.dataset.aeenTrackBound !== '1') {
      track.dataset.aeenTrackBound = '1';
      var timer = 0;
      track.addEventListener('scroll', function () {
        window.clearTimeout(timer);
        timer = window.setTimeout(syncArrows, 70);
      }, { passive: true });
      window.addEventListener('resize', syncArrows, { passive: true });
    }

    syncArrows();
    window.setTimeout(syncArrows, 300);
  };

  function initTabs(root) {
    if (!root || root.dataset.aeenTabsBound === '1') return;
    var nav = root.querySelector('.aeen-cs__tabnav');
    if (!nav) return;
    root.dataset.aeenTabsBound = '1';
    var glider = nav.querySelector('.aeen-cs__glider');
    var section = root.closest('.aeen-cs');

    function move(pill) {
      if (!glider || !pill) return;
      glider.style.width = pill.offsetWidth + 'px';
      glider.style.transform = 'translateX(' + pill.offsetLeft + 'px)';
      glider.classList.add('is-ready');
    }

    nav.querySelectorAll('.aeen-cs__pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        nav.querySelectorAll('.aeen-cs__pill').forEach(function (item) {
          item.classList.remove('is-on');
        });
        section.querySelectorAll('.aeen-cs__pane').forEach(function (pane) {
          pane.classList.remove('is-on');
        });
        pill.classList.add('is-on');
        move(pill);
        var pane = section.querySelector('.aeen-cs__pane[data-pane="' + pill.dataset.tab + '"]');
        if (pane) {
          pane.classList.add('is-on');
          window.aeenTrack(pane);
          var viewAll = section.querySelector('[data-viewall]');
          if (viewAll && pill.dataset.url) viewAll.href = pill.dataset.url;
        }
        pill.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });
    });

    function position() {
      move(nav.querySelector('.aeen-cs__pill.is-on'));
    }

    window.requestAnimationFrame(position);
    window.setTimeout(position, 350);
    window.addEventListener('resize', position, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(position);
  }

  function boot(root) {
    var scope = root || document;
    scope.querySelectorAll('.aeen-cs__tabs').forEach(initTabs);
    scope.querySelectorAll('.aeen-cs__pane.is-on, .aeen-cs__slab, [data-aeen-products-ready]').forEach(function (section) {
      window.aeenTrack(section);
    });
    syncButtons(scope);
  }

  function start() {
    boot(document);
    if (window.AEENCartDrawer && typeof window.AEENCartDrawer.getCart === 'function') {
      var existingCart = window.AEENCartDrawer.getCart();
      if (existingCart) adoptCart(existingCart);
      else window.setTimeout(function () {
        if (!cartState) fetchCart(true).catch(function () {});
      }, 1500);
    } else {
      fetchCart(true).catch(function () {});
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
  document.addEventListener('aeen:products:rendered', function () {
    boot(document);
  });
  document.addEventListener('aeen:cart:updated', function (event) {
    var cart = event.detail && event.detail.cart;
    if (cart && cart !== cartState) adoptCart(cart);
  });
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) fetchCart(true).catch(function () {});
  });
})();
